import { Component, Input } from '@angular/core';
import { LocationStatusItem } from 'src/app/model/location-status-item';

@Component({
  selector: 'app-machine-list',
  templateUrl: './machine-list.component.html',
  styleUrls: ['./machine-list.component.scss'],
})
export class MachineListComponent {
  // @Input() machineName: string;

  machineName: string;

  location: LocationStatusItem;

  constructor() {
    console.log(this.machineName);
    console.log(this.location);
  }
}
